import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue, white, gray01, gray06, warningBackground } = colors;

export const TableContainer = styled.div`
  .table-responsive {
    min-height: 350px;
    padding: 32px;
    background-color: ${white};
    border-radius: 10px;
    box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
      0px 3px 4px rgba(215, 220, 230, 0.12),
      0px 3px 3px rgba(215, 220, 230, 0.14);
  }

  tbody tr {
    cursor: pointer;
    transition: all 0.2s ease-in;

    &:hover {
      background-color: ${warningBackground};
    }
  }

  tbody tr.active {
    background-color: ${warningBackground};
  }

  td {
    font-size: 14px;
    color: ${gray01};

    span {
      color: ${gray01};
      font-weight: 700;
    }
  }

  tr td {
    vertical-align: middle;
  }

  tr th[scope='col'] {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 14px;
    color: ${darkBlue};
  }

  th,
  td {
    padding: 15px;
  }

  thead th,
  tbody tr {
    border-bottom: 1px solid ${gray06} !important;
  }

  tbody th,
  tbody td {
    border: 0;
  }

  tbody tr:not(:last-child) {
    border-bottom: 1px solid ${gray06} !important;
  }
`;
